module.exports = __webpack_public_path__ + "img/integration4.46666c4b.png";